import { FC } from 'react';
import { img } from '@/helpers/utils';
import IcoAvatar from '@/assets/svg/ico_user_avatar.svg?react';
import styles from '@/components/elems/LinkToProfile/AvatarIcon/AvatarIcon.module.scss';
import { AvatarIconPropsIF } from '@/components/elems/LinkToProfile/AvatarIcon/AvatarIcon.types';

const AvatarIcon: FC<AvatarIconPropsIF> = ({ avatar, isTemporary }) => (
    <div className={styles.avatarCircleWrapper}>
        {avatar ? (
            <img src={isTemporary ? avatar : img(avatar)} alt="avatar" />
        ) : (
            <IcoAvatar />
        )}
    </div>
);

export default AvatarIcon;
